__turbopack_context__.v({
  "icon": "QNOLdW_icon",
});
